import { Navigate } from "react-router";
import { BetaAgreementGateProvider } from "@/components/BetaAgreementGateProvider";
import { AppShellSkeleton } from "@/components/LoadingSkeleton";
import { useAuth } from "@/lib/shared/auth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <AppShellSkeleton />;
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return <BetaAgreementGateProvider>{children}</BetaAgreementGateProvider>;
}
